import React, { Component } from 'react';
import Envelope from './Envelope';
// import * as firebase from 'firebase';

class Run extends Component {
  constructor(props) {
    super(props)
    this.state = { envelope: {} }
  }

  // componentDidMount() {
  //   this.setState({ key: this.props.match.params.key });
  //
  //   var ref = firebase.database().ref().child('/public-envelopes-full/' + this.props.match.params.key)
  //   ref.once('value', function(snap) {
  //     const env = snap.val();
  //     env.envKey = this.props.match.params.key;
  //     this.setState({ envelope: env })
  //   }.bind(this))
  // }

  render() {
    return  (
      <Envelope user={this.props.user} isNew={false}/>
    )
  }
}

export default Run



// WEBPACK FOOTER //
// ./src/Run.js